import '../review/new.js';

/* global DialogUtils */
$(document).on("turbo:load", function() {
    if (!document.querySelector('#missing-dentist-dialog')) {
      return;
    }

    DialogUtils.setupDialog($('#missing-dentist-dialog'));

    $('.missing-dentist-action').click(function() {
      $('#missing-dentist-dialog').dialog('open');
      return false;
    });

    /* global NewReview */
    NewReview.setupSelector($("#dentist-selector"));
});
